import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { Mail, Loader2, AlertCircle, CheckCircle, ArrowLeft } from 'lucide-react';

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ state: 'idle', msg: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'loading', msg: '' });

    try {
      await forgotPassword(email);
      setStatus({ state: 'success', msg: 'If an account exists with this email, you will receive a reset link.' });
    } catch (err) {
      setStatus({ state: 'error', msg: err.message });
    }
  };

  return (
    <Layout>
      <section className="min-h-[80vh] flex items-center justify-center bg-slate-50 py-16">
        <div className="w-full max-w-md px-4">
          <div className="text-center mb-8">
            <h1 className="font-heading text-3xl font-bold text-navy mb-2">
              Reset Password
            </h1>
            <p className="text-slate-600">
              Enter your email to receive a reset link
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm"
            data-testid="forgot-password-form"
          >
            <div className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-navy mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="input-field pl-11"
                    placeholder="you@email.com"
                    data-testid="forgot-email"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={status.state === 'loading'}
                className="w-full btn-copper justify-center disabled:opacity-60"
                data-testid="forgot-submit"
              >
                {status.state === 'loading' ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Sending...
                  </>
                ) : (
                  'Send Reset Link'
                )}
              </button>

              {status.state === 'success' && (
                <div className="rounded-xl px-4 py-3 bg-green-50 text-green-800 border border-green-200 flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">{status.msg}</span>
                </div>
              )}

              {status.state === 'error' && (
                <div className="rounded-xl px-4 py-3 bg-red-50 text-red-800 border border-red-200 flex items-start gap-3">
                  <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">{status.msg}</span>
                </div>
              )}
            </div>
          </form>

          <Link
            to="/login"
            className="flex items-center justify-center gap-2 mt-6 text-slate-600 hover:text-copper"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to login
          </Link>
        </div>
      </section>
    </Layout>
  );
}
